import { createSlice } from "@reduxjs/toolkit";
import { getAllV2DasboardTasks, getTaskSubTask } from "../thunks/dashboard";

const initState = {
  isNote: false,
  isAnniversaryDrawer: false,
  subTasks: {},
  allMainTasks: [],
};

const dashboardSlice = createSlice({
  name: "dashboardSlice",
  initialState: initState,
  reducers: {
    updateNotesDrawer: (state, action) => {
      const tempData = JSON.parse(JSON.stringify(state?.isNote));
      state.isNote = !tempData;
    },
    updateAnniversariesDrawer: (state, action) => {
      const tempData = JSON.parse(JSON.stringify(state?.isAnniversaryDrawer));
      state.isAnniversaryDrawer = !tempData;
    },
    updateSubTask: (state, action) => {
      const { subTaskid, subTaskData, parentTaskId, operation } =
        action.payload;

      const existingTasks = state?.subTasks?.[parentTaskId] || [];

      let updatedData = existingTasks;

      // Update only isPickedButton and isDroppedButton
      updatedData = existingTasks?.map((subTask) =>
        subTask.id === subTaskid
          ? {
              ...subTask,
              isPickedButton: subTaskData.isPickedButton,
              isDroppedButton: subTaskData.isDroppedButton,
              isCompleteButton: subTaskData?.isCompleteButton,
              status: subTaskData?.status,
              assignedToUserDetails: subTaskData?.assignedToUserDetails,
              modifiedBy: subTaskData?.modifiedBy,
              NewTaskBranching: subTaskData?.NewTaskBranching,
            }
          : subTask
      );

      state.subTasks[parentTaskId] = updatedData;
    },
    updateMainTask: (state, action) => {
      const { taskId, taskData, operation } = action.payload;

      const existingTasks =
        JSON.parse(JSON.stringify(state?.allMainTasks)) || [];
      let updatedData = existingTasks;

      if (operation === "Completed") {
        // Remove the mainTask
        updatedData = existingTasks?.filter((task) => task.id !== taskId);
      } else if (operation === "Picked" || operation === "Dropped") {
        // Update only isPickedButton and isDroppedButton in the mainTask
        updatedData = existingTasks?.map((task) =>
          task.id === taskId
            ? {
                ...task,
                isPickedButton: taskData?.isPickedButton,
                isDroppedButton: taskData?.isDroppedButton,
                isCompleteButton: taskData?.isCompleteButton,
                status: taskData?.status,
                assignedToUserDetails: taskData?.assignedToUserDetails,
                modifiedBy: taskData?.modifiedBy,
                NewTaskBranching: taskData?.NewTaskBranching,
              }
            : task
        );
      }

      state.allMainTasks = updatedData;
    },
  },
  extraReducers: (builder) => {
    builder

      // Get all Tasks FORWORKFLOW
      .addCase(getAllV2DasboardTasks.pending, (state, action) => {
        state.loading = true;
        state.allMainTasks = [];
      })

      .addCase(getAllV2DasboardTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.allMainTasks = action?.payload?.allTasks;
      })

      .addCase(getAllV2DasboardTasks.rejected, (state, action) => {
        state.loading = false;
      })
      // Get Task specific subTasks
      .addCase(getTaskSubTask.pending, (state, action) => {
        state.loading = true;
      })

      .addCase(getTaskSubTask.fulfilled, (state, action) => {
        state.loading = false;
        state.subTasks[action?.payload?.id] = action?.payload?.data;
      })

      .addCase(getTaskSubTask.rejected, (state, action) => {
        state.loading = false;
        state.planData = [];
      });
  },
});
export const {
  updateNotesDrawer,
  updateAnniversariesDrawer,
  updateSubTask,
  updateMainTask,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
